import * as React from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";

import Page from "@/components/Page";
import { Hero, Journey, Qualities, Techstack } from "./components";
import { HeroBg } from "@/components";
import { TransitionContext } from "@/contexts/TransitionContext";

/**
 * Renders the about page
 * Shows the hero section, journey section, techstack section and qualities section
 */
const AboutPage = () => {
  const container = React.useRef<HTMLDivElement>(null);

  const { timeline } = React.useContext(TransitionContext);

  useGSAP(
    () => {
      gsap.fromTo(container.current, { opacity: 0 }, { opacity: 1 });
      timeline.add(gsap.to(container.current, { opacity: 0 }));
    },
    { scope: container }
  );

  return (
    <div ref={container}>
      <Page pageTitle="Tarun Sharma • About">
        <HeroBg />
        <Hero />
        <Journey />
        <Techstack />
        <Qualities />
      </Page>
    </div>
  );
};

export default AboutPage;
